import {useControlledState as $b3nuO$useControlledState} from "@react-stately/utils";


function $587d3ad58be6d31f$export$daff6da51032a415(props = {
}) {
    let [selectedValues, setValue] = $b3nuO$useControlledState(props.value, props.defaultValue || [], props.onChange);
    const state = {
        value: selectedValues,
        setValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue(value);
        },
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isSelected (value) {
            return selectedValues.includes(value);
        },
        addValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (!selectedValues.includes(value)) setValue(selectedValues.concat(value));
        },
        removeValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value
            ));
        },
        toggleValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value
            ));
            else setValue(selectedValues.concat(value));
        },
        validationState: props.validationState
    };
    return state;
}




export {$587d3ad58be6d31f$export$daff6da51032a415 as useCheckboxGroupState};
//# sourceMappingURL=module.js.map
